(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('etrrbApp')
        .constant('ETRRB_STATUS', {
        	 'NEW': {
				code: 'NEW',
				name: 'Chờ nộp tiền'
			},
			'SUCCESS': {
				code: 'SUCCESS', 
				name: 'Đã nộp tiền',
			},
			'ERROR': {
				code: 'ERROR', 
				name: 'Lỗi',
			},		
			'CANCEL': {
				code: 'CANCEL', 
				name: 'Đã hủy',
			}
        	
        })
        .constant('ETRRB_STATUS_SYNC', {
        	 'NEW': {
				code: 'NEW',
				name: 'Chờ nộp tiền'
			},
			'SUCCESS': {
				code: 'SUCCESS', 
				name: 'Đã nộp tiền',
			}
        })
        .constant('ETRRB_BOOKLET_TYPE', {
       	 'TR': {
				code: 'TR',
				name: 'Phiếu thu điện tử TR'
			},
			'RB': {
				code: 'RB', 
				name: 'Phiếu thu điện tử RB',
			}
        })
        .constant('ETRRB_TXN_TYPE', {
       	 'TR': {
				code: '100',
				name: 'Phiếu thu điện tử TR'
			},
			'RB': {
				code: '200', 
				name: 'Phiếu thu điện tử RB',
			}
        })
       .constant('ETRRB_PAY_METHOD', {
        	 'CASH': {
				code: 'CASH',
				name: 'Tiền mặt'
			},
			'BANK': {
				code: 'BANK', 
				name: 'Ngân hàng',
			},
			'POST': {
				code: 'POST', 
				name: 'Bưu điện',
			}
        })
        .constant('ETRRB_REASON_CANCEL', {
        	'01': {
				code: '01',
				name: 'Nhập nhầm số HĐ/HSYCBH'
			},
			'02': {
				code: '02', 
				name: 'TVV thu phí bằng PT giấy',
			},
			'03': {
				code: '03', 
				name: 'Khách hàng đổi ý',
			},
			'04': {
				code: '04', 
				name: 'Khác',
			}
        })
})();